import { SocialNetwork, SocialNetworkIcons } from '../community.model';
import { HeaderLink, ProfileSocialNetworks } from '../interfaces';

export const getSocialLinks = (
  links: ProfileSocialNetworks,
  additionalLinks: Record<string, HeaderLink> = {}
): HeaderLink[] => {
  const linkObj = links || {};
  const keys = Object.keys(SocialNetworkIcons);
  const socialLinks: HeaderLink[] = [];

  keys.forEach(key => {
    if (linkObj[key]) {
      socialLinks.push({
        title: SocialNetworkIcons[key as SocialNetwork].title,
        link: linkObj[key],
        icon: SocialNetworkIcons[key as SocialNetwork].icon,
        type: key,
      });
    }
  });

  return [...socialLinks, ...Object.values(additionalLinks ?? {})];
};
